import { OrganizeByCategoryResult } from './organize-by-category';

const filterMenuData = (menuData: OrganizeByCategoryResult, searchTerm: string) => {
    return menuData.reduce((acc, curr) => {
        const matchingOptions = curr.options.filter(option =>
            option.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );
        if (matchingOptions.length > 0) {
            acc.push({
                ...curr,
                options: matchingOptions,
            });
        }
        return acc;
    }, [] as OrganizeByCategoryResult);
};

export default filterMenuData;
